import { makeStyles } from "@material-ui/core/styles";

const fieldTemplatesStyles = makeStyles((theme) => ({
  root: {
    width: "450px",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    borderRadius: "10px",
    color: theme.palette.text.tertiary,
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "18px 30px ",
    position: "relative",
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: "25px",
    fontWeight: "700",
  },
  closeIcon: {
    color: theme.palette.text.primary,
    cursor: "pointer",
  },
  displayFlex: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  iconStyle: {
    width: "100%",
    marginTop: "18%",
    color: theme.palette.text.primary,
  },

  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },
  cardContentDiv2: {
    width: "50%",
    height: "5rem",
    display: "grid",
    placeItems: "center",
    border: `2px solid ${theme.palette.text.primary}`,
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },
  cardContentInput1: {
    padding: "0.2px 6px",
  },
  cardContentInput2: {
    padding: "2px 8px",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    width: "100%",
    height: "40px",
  },

  autoComplete: {
    width: "100%",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "5px",
  },
  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },
  cancelButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
  },

  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px",
    padding: "0px",
  },
  labelText: {
    display: "block",
    borderRadius: "5px",
    color: theme.palette.text.tertiary,
    cursor: "pointer",
    textAlign: "center",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },

  menuPop: {
    margin: "0px",
    backgroundColor: theme.palette.secondary.light,
  },

  modalButton: {
    width: "180px",
    height: "45px",
    borderRadius: "15px",
    borderColor: theme.palette.secondary.light,
    background: theme.palette.secondary.light,
    fontFamily: "Nunito sans",
    textAlign: "center",
    color: theme.palette.text.primary,
  },
}));

export default fieldTemplatesStyles;
